var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheRealityBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    width: 8839.89,
    height: 5365.347,
    viewBox: "0 0 8839.89 5365.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M3336.2,5113.6c351.233,246.737,902.758,296.691,1405.535,277.733,1577.9-61.8,3002.213-414.7,4234.3-1093.3,0-239.706,0-3788.454,0-3971.06C8359.028,93.794,7499.122,100.01,6798.822,46.454,6299.536,8.538,5793.991,39.345,5297.474,92.333c-1387,148.155-2748.481,475.746-3889.688,1036.14C907.3,1374.261,435.333,1679.863,229.263,2077.5S155,2979.043,666.078,3214.405c211.366,97.349,464.139,141.331,711.495,182.659,364.233,60.759,734.245,120.667,1062.848,244.177,339.558,127.586,741.467,374.323,674.061,656.794C3042.5,4601.076,2984.725,4867.15,3336.2,5113.6Z",
    transform: "translate(8976.034 5394.964) rotate(180)",
    fill: "#0e7f8a",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheRealityBack);
export default __webpack_public_path__ + "static/media/TheRealityBack.002fffdce7078ebab207b00586cc35f7.svg";
export { ForwardRef as ReactComponent };